export default {
  id: '68ee7eb741',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n    <div class="page" data-name="login">\r\n      <!-- <div class="navbar paymentPage no-shadow modern-navbar">\r\n        <div class="navbar-bg"></div>\r\n        <div class="navbar-inner">\r\n            <div class="title">\r\n              <span class="text-color-red fw-500" style="font-size:18px;">Login to Vyoora</span>\r\n            </div>\r\n          </div>\r\n      </div> -->\r\n      \r\n        <div class="page-content flex center">\r\n          <img src="assets/icons/icon_wide.png" alt="" height="150">\r\n            <div class="block block-auth mt-2 mb-4" style="text-align:center;">\r\n                <div class="preloader color-red"></div>\r\n                <p class="h3 text-color-red fw-500">Authenticating...</p>\r\n                <p class="text-color-gray">Please wait while we log you in securely.</p>\r\n            </div>\r\n        </div>\r\n  </div>\r\n';
      return r;
    }(this);
  },
  styleScoped: false
};